import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import { Button, Menu, MenuItem } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import dayjs from 'dayjs';
import React, { useState } from 'react';
import Swal from 'sweetalert2';
import * as yup from 'yup';
import strings from '../Globalization/index';
import consts from '../consts';
import Model from '../models/model';
import Connection from '../services/Connection';
import util from '../util';
import CatAdminForm from '../views/forms/CatAdminForm';
import { useGridBase } from '../components/grid/GridBaseContext';
import { syncFieldTests } from './UserSyncTable';

const { nonHuluScopes } = consts;

export const { unitArrayConverter, canPrint, isGridReadOnly, isHuluAdmin, canAdd, viewOnly, deviceTypeRenderr, isVisible, checkUserRoleAccess, isFromTrackingSystem } = util;
const { EquipmentType } = consts;
const { AER, CABINET } = EquipmentType;
const huluScopes = ['A', 'l', 'INNOV', 'IA', 'RAER', 'EDRY', 'ISA'];
/**
 * @dsec UUId is not handel ad backend so its commited out once its handeled so uncomment it
 * And other field are comment becuase the array of obj funcationailty is not written once its written uncomment it 
 */

const dataSourceCheck = ({ formik }) => {
	if (formik?.values?.DataSource === 'Equipment') {
		return true;
	} else {
		return false;
	}
}
const onNewHideColumn = ({ formik, activeRecord }) => {
	return Boolean(formik?.values?.Id);

}

const CustomCheckBox = ({ id, row, value }) => {
	const { rowSelectionModel, onRowSelectionModel } = useGridBase();
	const handleOnClick = () => {
		const result = rowSelectionModel.find(item => item === row._id);
		if(result)
		{
			const updatedRowSelectionModel = rowSelectionModel.filter(item => item !== row._id);
			onRowSelectionModel(updatedRowSelectionModel);
		}
		else{
			rowSelectionModel.push(row._id);
			onRowSelectionModel(rowSelectionModel);
		}
	}

	const handleChecked = () => {
		return rowSelectionModel.some(item => item === row._id);
	}
	return (
		<Checkbox
			checked={handleChecked()}
			onClick={handleOnClick}
			disabled={viewOnly()}
			color="primary"
			value={row?.id}
			inputProps={{ 'aria-label': 'checkbox' }}
		/>
	)
}

const onExportToURSX = async (name, extension, type, data, EquipmentTypeId) => {
	const { rows } = data;
	const fileName = `${name}_${dayjs().format(consts.CantelTimeFormat)}${extension}`;
	const formValue = new FormData();
	let response;
	formValue.append("action", 'otherAction');
	if (rows.length !== 0) {
		formValue.append('exportFormat', extension);
		formValue.append('exportType', type);
		formValue.append("otherAction", 'HandleExport');
		formValue.append("EquipmentTypeId", EquipmentTypeId);

		try {
			response = await fetch(`${Connection.ItemSync}?v=${new Date()}`, {
				method: 'POST',
				body: formValue
			});
			response.blob().then((b) => {
				let a = document.createElement("a");
				a.href = URL.createObjectURL(b);
				a.setAttribute("download", fileName);
				a.click();
			});
		} catch (err) {
			const result = await response.json();
			if (result.info) {
				Swal.fire({
					title: "Error",
					text: strings[result.info],
					icon: "error",
					confirmButtonText: strings.Ok,
					allowOutsideClick: false
				})
			}
		}
	} else {
		Swal.fire({
			title: "Error",
			text: strings.ThereIsNoRecordAvailableForExport,
			icon: "error",
			confirmButtonText: strings.Ok,
			allowOutsideClick: false
		})
	}
};


const CombinedExport = ({ data, onExport }) => {
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};
	const handleOnExport = async (type) => {
		await onExport(type)
	}
	return (isHuluAdmin()) ? <span /> : (
		<div>
			<Button
				id="fade-button"
				aria-controls={open ? 'fade-menu' : undefined}
				aria-haspopup="true"
				aria-expanded={open ? 'true' : undefined}
				onClick={handleClick}
				color='primary'
				variant='contained'

			>
				<FileDownloadOutlinedIcon />
				{strings.Export}
			</Button>
			<Menu
				id="fade-menu"
				MenuListProps={{
					'aria-labelledby': 'fade-button',
				}}
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
			>
				<MenuItem onClick={() => onExportToURSX('Scopes', '.STRX', 'Scopes', data, AER)}>{strings.AdvXmlStrxFile}</MenuItem>
				<MenuItem onClick={() => onExportToURSX('EndoDry Scope', '.csv', 'Scopes', data, CABINET)}>{strings.EndoDryExport}</MenuItem>
				<MenuItem onClick={() => handleOnExport('XLSX')}>{strings.ExcelUserGrid}</MenuItem>
				<MenuItem onClick={() => handleOnExport('CSV')}>{strings.CsvUserGrid}</MenuItem>
				<MenuItem onClick={() => handleOnExport('PDF')}>{strings.PdfUserGrid}</MenuItem>
			</Menu>
		</div>
	)
}
const ImportButton = (params) => {

	const handleFileChange = async (e) => {
		const file = e.target.files[0];
		e.target.value = '';
		if (!file) return;

		if (!file.type.includes('text/csv') && !file.name.endsWith('.xlsx')) {
			showError(strings.FileValidation);
			return;
		}

		try {
			const response = await uploadFile(file);
			const result = await response.json();

			if (result.info) {
				showError(strings[result.info] || result.info);
			}
		} catch (err) {
			console.error(err);
		}

		params?.onRefresh();
	};

	const uploadFile = (file) => {
		const formData = new FormData();
		formData.append("file", file);
		formData.append("action", 'otherAction');
		formData.append("otherAction", 'HandelImportFile');

		return fetch(Connection.EndoSetupScope, {
			method: 'POST',
			body: formData,
		});
	};

	const showError = (message) => {
		Swal.fire({
			title: "Error",
			text: message,
			icon: "error",
			confirmButtonText: strings.Ok,
			allowOutsideClick: false
		});
	};

	return (isHuluAdmin()) ? <span /> : (
		<label htmlFor="upload-file">
			<input
				style={{ display: 'none' }}
				id="upload-file"
				name="upload"
				type="file"
				accept=".xlsx,.csv"
				onChange={(e) => {
					handleFileChange(e);
				}}
			/>
			<Button
				variant="contained"
				component="span"
				style={{ padding: '0px 18px', height: '30px' }}
				startIcon={<ImportExportIcon />}
			>
				{strings.Import}
			</Button>
		</label>
	)
}
const fetchUserType = async ({ activeRecord }) => {
	const { record = {} } = activeRecord || {}
	const { id = null, Parameters = [] } = record;
	let inValue = ''
	const isHuluScope = Parameters.find((parameter) => parameter.Key === 'HuluScopeModelId' && !!parameter.Value);
	if (isHuluScope && !!id) {
		inValue = huluScopes;
	} else {
		inValue = nonHuluScopes;
	}
	const where = { CustomStringValue: { $exists: true, $in: inValue } }
	const formData = new FormData();
	formData.append('comboType', 'DeviceType');
	formData.append('CustomeWhere', JSON.stringify(where))
	const { options, count } = await fetch(Connection.Combo, {
		method: 'POST',
		body: formData
	}).then((res) => res.json()).then((json) => {
		const { records } = json;
		let options = records?.map((record) => ({
			id: record.LookupId,
			label: record.DisplayValue
		}));
		if (!Array.isArray(options)) {
			options = [];
		}
		return { options: options || [], count: options?.length };
	});
	return { options, count };
}

const model = new Model({
	name: 'Nonmedivator',
	idProperty: "_id",
	disableAdd: canAdd,
	readOnly: isGridReadOnly,
	isRevisionLogBtn: true, // adding this Property to Get Revision Log button on Form Screen.
	allowDelete: false,
	disableDelete: true,
	disableExport: true,
	filter: [{ "operator": "$eq", "property": "IsActive", "value": true }],
	disablePrintBarcode: false,
	disableSelectAll: false,
	defaultSort: 'ItemName ASC',
	showGridRefreshBtn: true,
	customizeSaveData: (toSave, { activeRecord, values }) => {
		toSave.RemoveCodes = JSON.stringify(activeRecord?.record?.RemoveCodes || []);
		toSave.Parameters = JSON.stringify(values?.Parameters || []);
		toSave.ItemCodes = JSON.stringify(values?.ItemCodes || [])
		toSave.DeviceTypes = JSON.stringify(values?.DeviceTypes || [])
		return toSave;
	},
	gridToolbarCustomActions: [
		{
			Component: CombinedExport
		},
		{
			Component: ImportButton,
		}
	],
	FormExtension: ({ formik, activeRecord, isNew, modelConfig }) => {
		return (
			<CatAdminForm activeRecord={activeRecord} formik={formik} isDeviceType={false} modelConfig={modelConfig}
				isNew={isNew}
				isItemSync={true}
			/>
		)
	},
	onFormLoad: ({ formik, activeRecord, locationState, searchParams, location }) => {

		if (!formik.values.id) {
			formik.setFieldValue('IsActive', true);
			formik.setFieldValue('ItemType', 'Scope');
		}
	},
	formGroups: [{
		fields: ["ItemName", "Manufacturer", "ItemType", "Model", "SerialNumber", "IsActive", "ReSync",
			"LastResyncOn", "InterFacedYN", "DataSource", "EquipmentName", "DeviceTypes", "ItemCodes", "EquipmentModel",
		]
	}],
	columns: [
		{ field: 'ItemUID', width: 150, hidden: true, readOnly: true, inputWhen: onNewHideColumn },
		{ field: 'ItemName', width: 150, required: true, readOnly: viewOnly(false) },
		{ header: 'ItemType', field: 'ItemType', width: 150, readOnly: true, defaultValue: 'Scope' },
		{ header: 'SerialNumberSecond', field: 'SerialNumber', width: 150 },
		{ header: 'Active', field: 'IsActive', type: 'bool', width: 200, readOnly: viewOnly(false), defaultValue: true, onChange: ({ formik, value }) => { formik.setFieldValue('ReSync', value) } },
		{ header: 'code', field: 'CodesCount', width: 150, isNotformfield: true },
		{ header: 'Status', field: 'Status', width: 150, hidden: true, readOnly: true, inputWhen: onNewHideColumn },
		{ field: 'DataSource', width: 150, inputWhen: onNewHideColumn, readOnly: true },
		{ field: 'createdAt', type: 'date', readOnly: true, isLocal: true, format: 'MM/DD/YYYY hh:mm:ss A', hidden: true, inputWhen: onNewHideColumn },
		{ header: 'Last Updated', field: 'ModifiedOn', type: 'date', isLocal: true, format: 'MM/DD/YYYY hh:mm:ss A', readOnly: true, inputWhen: onNewHideColumn },
		{
			field: 'ItemCodes', width: 150, hidden: true, type: 'object', validate: yup.array().of(
					yup.object().shape({
						CodeType: yup.string().required(),
						Code: yup.string(),
						IsActive: yup.boolean(),
						DefaultValue: yup.boolean(),
						RFIDTagNumber: yup.string(),
						RFIDEquipmentID: yup.string()
					})
				)
				.test(syncFieldTests.DuplicateBarcodeFound)
				.test(syncFieldTests.AtLeastOneBarcodeisRequired)
				.test(syncFieldTests.AtLeastOneDefaultBardcodeisRequired)
				.test(syncFieldTests.OverDefaultBarcodeFound)
				.test(syncFieldTests.CodeisRequired)
				.test(syncFieldTests.CodeLengthMax100)
				.test(syncFieldTests.DuplicateISARFIDFound)
				.test(syncFieldTests.DuplicateRapidRFIDTagFound),
			excludeOnGrid: true,
			isNotExportField: true,
			isNotformfield: true
		},
		{
			header: 'Parameters', field: 'Parameters', width: 150, lookup: 'ItemSyncParameters', hidden: true, type: 'object', validate: yup.array().of(
				yup.object().shape({
					Key: yup.string().required(),
					Value: yup.string().required()
				})
			),
			excludeOnGrid: true,
		},
		{ field: 'ReSync', type: 'bool', hidden: true, width: 200, inputWhen: onNewHideColumn, readOnly: viewOnly(false), onChange: ({ formik, value }) => { formik.setFieldValue('IsActive', value) }, defaultValue: true },
		{ field: 'LastResyncOn', type: 'date', format: 'MM/DD/YYYY hh:mm:ss A', hidden: true, width: 200, readOnly: true, inputWhen: onNewHideColumn },
		{ field: 'ModifiedBy', hidden: true, width: 200, readOnly: true, inputWhen: onNewHideColumn },
		{ header: 'Published', field: 'Published', hidden: true, width: 200, isNotformfield: false },
		{ header: 'Equipment', field: 'EquipmentName', width: 220, hidden: true, inputWhen: dataSourceCheck },
		{ field: 'Regions', width: 120, hidden: true, type: 'object' },
		{ header: 'Print Barcode', field: 'Print', type: 'action', width: 120, renderCell: CustomCheckBox, isNotExportField: true },
		{ field: 'DeviceTypes', header: 'DeviceTypes', width: 120, hidden: true, lookup: fetchUserType, multiple: true, type: 'object', valueGetter: deviceTypeRenderr, readOnly: isFromTrackingSystem, inputWhen: isVisible },
		{ header: 'EquipmentModel', field: 'EquipmentModel', width: 120, lookup: 'Model', multiple: true, readOnly: true, inputWhen: checkUserRoleAccess },
	],
	extraExportConfig: {
		PDF: {
			pageSize: 'A2'
		}
	}
});

export const ItemSyncModel = model;

export default model.createFormBase();